import React from "react";
import styles from "./style.module.scss";
import TvEnergyDataManager from "../../../components/DataManagers/TVEnergyDataManager";
import EnergyGraphDelta from "../../../components/TVEnergy/EnergyGraphDelta";
import TargetGraph from "../../../components/TVEnergy/TargetGraph";

function TVEnergyGraphPage() {
  const [selectedView, setSelectedView] = React.useState<
    "graph" | "delta9" | "delta13"
  >("graph");

  return (
    <div className={styles.fullscreen}>
      <div className={styles.energyGraphContainer}>
        <TvEnergyDataManager />

        <div className={styles.radioMenu}>
          <label>
            <input
              type="radio"
              name="energyView"
              value="graph"
              checked={selectedView === "graph"}
              onChange={() => setSelectedView("graph")}
            />
            ENERGY GRAPH
          </label>
          <label>
            <input
              type="radio"
              name="energyView"
              value="delta9"
              checked={selectedView === "delta9"}
              onChange={() => setSelectedView("delta9")}
            />
            Δ EVA
          </label>
          <label>
            <input
              type="radio"
              name="energyView"
              value="delta13"
              checked={selectedView === "delta13"}
              onChange={() => setSelectedView("delta13")}
            />
            Δ DAC
          </label>
        </div>
        <div className={styles.energyGraph}>
          {selectedView === "graph" && <TargetGraph />}
          {selectedView === "delta9" && (
            <EnergyGraphDelta compareDriver={"9"} />
          )}
          {selectedView === "delta13" && (
            <EnergyGraphDelta compareDriver={"13"} />
          )}
        </div>
      </div>
    </div>
  );
}

export default TVEnergyGraphPage;
